import React, { useState } from "react";
import Layout from "../form-layout";

// Q11 — "Are you currently taking any other medication?"
export default function Step9a({ formData, setFormData, onBack, goToStep }) {
  const [answer, setAnswer] = useState(formData.otherMedicationAnswer || "");
  const [details, setDetails] = useState(formData.otherMedicationDetails || "");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!answer) return;
    if (answer === "Yes" && !details.trim()) return;

    setFormData((prev) => ({
      ...prev,
      otherMedicationAnswer: answer,
      otherMedicationDetails: details,
    }));
    localStorage.setItem("otherMedicationAnswer", answer);
    localStorage.setItem("otherMedicationDetails", details);

    goToStep("10");
  };

  return (
    <Layout goToStep={goToStep} onBack={onBack}>
      <h2 className="text-sm sm:text-[14px] font-medium text-[#000000] mb-2">
        Are you currently taking any other medication?
      </h2>
      <p className="text-gray-500 mb-6 text-sm">
        This includes prescription, over the counter, purchased online or recreational drugs.
      </p>

      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <div className="flex gap-6">
          {["Yes", "No"].map((option) => (
            <label key={option} className="inline-flex items-center gap-2 cursor-pointer p-2">
              <input
                type="radio"
                name="otherMedicationAnswer"
                checked={answer === option}
                onChange={() => setAnswer(option)}
                className="h-4 w-4 accent-[#35C3D9]"
              />
              <span className="text-gray-800">{option}</span>
            </label>
          ))}
        </div>

        {answer === "Yes" && (
          <textarea
            value={details}
            onChange={(e) => setDetails(e.target.value)}
            placeholder="Please list the medication(s) you're taking."
            className="border border-gray-300 rounded-lg p-3 text-sm w-full min-h-[80px] focus:outline-none focus:ring-2 focus:ring-[#35C3D9]"
          />
        )}

        <div className="flex justify-start mt-2">
          <button
            type="submit"
            disabled={!answer || (answer === "Yes" && !details.trim())}
            className={`w-[210px] text-sm font-semibold rounded-lg py-3 transition-colors
              ${
                !answer || (answer === "Yes" && !details.trim())
                  ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                  : "bg-[#35C3D9] text-white hover:bg-[#27AAC0]"
              }`}
          >
            Next →
          </button>
        </div>
      </form>
    </Layout>
  );
}
